var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconPerson = function SvgIconPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.333a6.654 6.654 0 0 1 6.647 6.647 6.633 6.633 0 0 1-2.142 4.884c1.24.55 2.374 1.328 3.352 2.306a11.041 11.041 0 0 1 3.254 7.856v.285a1.356 1.356 0 1 1-2.712 0v-.285c0-4.63-3.768-8.399-8.399-8.399-4.631 0-8.4 3.768-8.4 8.4v.284a1.355 1.355 0 1 1-2.711 0v-.285c0-2.966 1.156-5.758 3.254-7.856a11.105 11.105 0 0 1 3.352-2.306l-.207-.2A6.632 6.632 0 0 1 7.353 8.98 6.654 6.654 0 0 1 14 2.333zm0 2.712a3.94 3.94 0 0 0-3.935 3.935A3.94 3.94 0 0 0 14 12.915c2.17 0 3.935-1.765 3.935-3.935S16.17 5.045 14 5.045z",
    fill: "none",
    fillRule: "evenodd"
  })));
};

export default SvgIconPerson;